import { Tooltip, TooltipContent, TooltipTrigger } from '@plato/ui/primitives/tooltip';
import { UserXIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../components/ui/button.tsx';
import { useAppState } from '../../../lib/hooks/use-app-state.ts';
import { useImpersonation } from '../../../lib/hooks/use-impersonation.ts';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import { getFullName } from '../../../utils/name.ts';

type ImpersonationBannerProps = {
    expanded?: boolean;
};

export function ImpersonationBanner({ expanded = true }: ImpersonationBannerProps) {
    const { t } = useLocale('common');
    const [impersonatedUserId, setImpersonatedUserId] = useImpersonation();
    const { platoUser } = useAppState();
    const navigate = useNavigate();

    if (!impersonatedUserId) {
        return null;
    }

    const exitImpersonation = () => {
        setImpersonatedUserId(undefined);
        void navigate(`/admin/customers/${encodeURIComponent(platoUser.platoCustomer.id)}`);
    };

    const fullName = getFullName(platoUser.firstName, platoUser.lastName);
    const customerName = platoUser.platoCustomer.name;
    const buttonLabel = `${customerName}${fullName ? ` (${fullName})` : ''}`;

    if (expanded) {
        return (
            <Tooltip>
                <TooltipTrigger
                    render={
                        <Button
                            variant="ghost"
                            onClick={exitImpersonation}
                            leftIcon={UserXIcon}
                            className="w-full min-w-0 justify-start [&>svg]:shrink-0"
                            aria-label={t('exit_demo__button')}
                        />
                    }
                >
                    <span className="truncate font-normal">{buttonLabel}</span>
                </TooltipTrigger>
                <TooltipContent side="right">{t('exit_demo__button')}</TooltipContent>
            </Tooltip>
        );
    }

    return (
        <Tooltip>
            <TooltipTrigger
                render={
                    <Button
                        variant="ghost"
                        onClick={exitImpersonation}
                        icon={UserXIcon}
                        aria-label={t('exit_demo__button')}
                    />
                }
            />
            <TooltipContent side="right">{buttonLabel}</TooltipContent>
        </Tooltip>
    );
}
